
export const nextStep=(step:string):string=>{
	const totalSteps:number=3;
	let stepValue:number=parseInt(step);
	console.log({step});
	return (stepValue<totalSteps)?
		`/onboarding/${++stepValue}`:'/dashboard/places';
};